import _ from 'lodash';
import jQuery from 'jquery';
import mapboxgl from 'mapbox-gl';
import Swiper from 'swiper';

let siteUrl = 'https://www.midlandsairambulance.com/';
let dataApi = '';

if (document.getElementById('missionsExplorer')) {
  const domain = document.getElementById('missionsExplorer');
  dataApi = domain.getAttribute('data-api-url');
  if (dataApi != "") {
    siteUrl = dataApi
  }
}
const apiUrl = `${siteUrl}api/missions/all`;

const mapboxPublicToken =
  'pk.eyJ1IjoibWFhY3dlYnNpdGUiLCJhIjoiY2w0cjI4N3RpMGR3bDNwcWhyanJtNTBuNSJ9.y1VG7_CNhVL8XV-HDEyXkw';

const app = {
  year: +jQuery('#missionsExplorer').attr('data-year'),
  month: +jQuery('#missionsExplorer').attr('data-month'),
};

($ => {
  if (!document.getElementById('missionsMap')) {
    return;
  }

  mapboxgl.accessToken = mapboxPublicToken;

  const mapCenter = [-1.668986, 52.822422];

  const map = new mapboxgl.Map({
    container: 'missionsMap',
    center: mapCenter,
    style: 'mapbox://styles/maacwebsite/cl4wnoimr000514od0yblsq79',
    zoom: 10,
    attributionControl: true,
  });

  let popup;

  function initMap() {
    map.scrollZoom.disable();
    map.addControl(new mapboxgl.NavigationControl(), 'bottom-right');

    map.on('load', () => {
      // Add a new source from our GeoJSON data and
      // set the 'cluster' option to true. GL-JS will
      // add the point_count property to your source data.
      map.addSource('missions', {
        type: 'geojson',
        // Point to GeoJSON data. This example visualizes all M1.0+ missions
        // from 12/22/15 to 1/21/16 as logged by USGS' Earthquake hazards program.
        data: {
          type: 'FeatureCollection',
          features: [],
        },
        cluster: true,
        clusterMaxZoom: 14, // Max zoom to cluster points on
        clusterRadius: 50, // Radius of each cluster when clustering points (defaults to 50)
      });

      map.addLayer({
        id: 'clusters',
        type: 'circle',
        source: 'missions',
        filter: ['has', 'point_count'],
        paint: {
          // Use step expressions (https://docs.mapbox.com/mapbox-gl-js/style-spec/#expressions-step)
          // with three steps to implement three types of circles:
          //   * Blue, 20px circles when point count is less than 100
          //   * Yellow, 30px circles when point count is between 100 and 750
          //   * Pink, 40px circles when point count is greater than or equal to 750
          'circle-stroke-width': 2,
          'circle-stroke-color': '#fff',
          'circle-color': [
            'step',
            ['get', 'point_count'],
            '#fff24b',
            5,
            '#fff24b',
            10,
            '#fff24b',
          ],
          'circle-radius': ['step', ['get', 'point_count'], 20, 5, 25, 10, 35],
        },
      });

      map.addLayer({
        id: 'cluster-count',
        type: 'symbol',
        source: 'missions',
        filter: ['has', 'point_count'],
        layout: {
          'text-field': '{point_count_abbreviated}',
          'text-font': ['DIN Offc Pro Medium', 'Arial Unicode MS Bold'],
          'text-size': 14,
        },
      });

      map.addLayer({
        id: 'unclustered-point',
        type: 'circle',
        source: 'missions',
        filter: ['!', ['has', 'point_count']],
        paint: {
          'circle-color': '#fff24b',
          'circle-radius': 10,
          'circle-stroke-width': 1,
          'circle-stroke-color': '#fff',
        },
      });

      // inspect a cluster on click
      map.on('click', 'clusters', e => {
        const features = map.queryRenderedFeatures(e.point, {
          layers: ['clusters'],
        });
        const clusterId = features[0].properties.cluster_id;
        map
          .getSource('missions')
          .getClusterExpansionZoom(clusterId, (err, zoom) => {
            if (err) return;

            map.easeTo({
              center: features[0].geometry.coordinates,
              zoom,
            });
          });
      });

      // When a click event occurs on a feature in
      // the unclustered-point layer, open a popup at
      // the location of the feature, with
      // description HTML from its properties.
      map.on('click', 'unclustered-point', e => {
        const coordinates = e.features[0].geometry.coordinates.slice();
        const properties = e.features[0].properties || {};

        const {
          assetSent,
          assetType = '',
          incidentType,
          url,
          missionDate,
        } = properties;

        let date;

        try {
          date = new Date(missionDate).toLocaleDateString();
        } catch (error) { }
        // Ensure that if the map is zoomed out such that
        // multiple copies of the feature are visible, the
        // popup appears over the copy being pointed to.
        while (Math.abs(e.lngLat.lng - coordinates[0]) > 180) {
          coordinates[0] += e.lngLat.lng > coordinates[0] ? 360 : -360;
        }

        let readMoreButton = ``;
        if (url && url != "") {
          readMoreButton = `<div class="mapboxgl-popup-content__button">
                            <a href="${siteUrl}${url}" target="_blank" >Read More</a>
                            </div>`;
        }
        const popupHtml = `<div class="mapboxgl-popup-content__header">
                            Mission Card</div>
                            <div class="mapboxgl-popup-content__body">
                            <div class="mapboxgl-popup-content__icon">
                                <div class="missions-explorer-icon missions-explorer-icon--${assetType.toLowerCase()}"></div></div>
                            <p><b>Date: </b>${date}</p>
                            <p><b>Asset Sent: </b>${assetSent}</p>
                            <p><b>Incident Type: </b>${incidentType}</p>
                            ${readMoreButton}
                            </div>`;

        popup = new mapboxgl.Popup({ maxWidth: '300px', offset: 15 })
          .setLngLat(coordinates)
          .setHTML(
            popupHtml
            ,
          )
          .addTo(map);
      });

      map.on('mouseenter', 'clusters', () => {
        map.getCanvas().style.cursor = 'pointer';
      });
      map.on('mouseleave', 'clusters', () => {
        map.getCanvas().style.cursor = '';
      });

      loadMissions();
    });

    new IntersectionObserver(
      (e, t) => {
        e[0].target.parentNode.toggleAttribute(
          'data-stuck',
          e[0].intersectionRatio < 1,
        );
      },
      {
        threshold: [1],
      },
    ).observe(document.querySelector('.trigger-box')),
      $('.map-filter').on('click', function (e) {
        $(this).hasClass('mapper')
          ? $('.map-data').toggleClass('show-filter')
          : $(this)
            .parent()
            .toggleClass('show-filter'),
          $(this).toggleClass('active'),
          e.preventDefault();
      });

    function getDirection() {
      return window.innerWidth > 600 ? 'vertical' : 'horizontal';
    }

    const sliderProps = {
      direction: getDirection(),
      spaceBetween: 1,
      slidesPerView: 5,
      slideToClickedSlide: true,
      centeredSlides: true,
      breakpoints: {
        600: {
          slidesPerView: 5,
        },
      },
    };

    const t = new Swiper('.years-slider', {
      initialSlide: 1,
      ...sliderProps,
      navigation: {
        nextEl: document.querySelector(
          '.years-slider-wrap .swiper-button-next',
        ),
        prevEl: document.querySelector(
          '.years-slider-wrap .swiper-button-prev',
        ),
      },
    });

    const i = new Swiper('.months-slider', {
      initialSlide: app.month,
      ...sliderProps,
      navigation: {
        nextEl: document.querySelector(
          '.months-slider-wrap .swiper-button-next',
        ),
        prevEl: document.querySelector(
          '.months-slider-wrap .swiper-button-prev',
        ),
      },
    });

    window.addEventListener('resize', () => {
      i.changeDirection(getDirection());
      t.changeDirection(getDirection());
    });

    t.on('slideChange', () => {
      const e = t.slides[t.activeIndex];
      app.year = +e.getAttribute('data-id');
      if (!app.year) {
        i.slideTo(0);
        i.disable();
      } else {
        i.enable();
      }
      loadMissions();
    });
    i.on('slideChange', () => {
      const e = i.slides[i.activeIndex];
      app.month = +e.getAttribute('data-id');
      loadMissions();
    });

    $('.months-slider-wrap .swiper-button-prev').on('click', e => {
      e.preventDefault();
      if (app.year) {
        i.slidePrev();
      }
    });
    $('.months-slider-wrap .swiper-button-next').on('click', e => {
      e.preventDefault();
      if (app.year) {
        i.slideNext();
      }
    });
    $('.years-slider-wrap .swiper-button-prev').on('click', e => {
      e.preventDefault();
      t.slidePrev();
    });
    $('.years-slider-wrap .swiper-button-next').on('click', e => {
      e.preventDefault();
      t.slideNext();
    });
  }

  const loadMissions = async () => {
    if (popup) popup.remove();
    const results = await fetch(
      `${apiUrl}${app.year ? `/${app.year}${app.month ? `/${app.month}` : ''}` : ''
      }`,
    )
      .then(response => response.json())
      .then(data => data.results)
      .catch(e => {
        return [];
      });

    const stats = results.reduce(
      (acc, curr) => {
        if (curr.assetType === 'Helicopter') {
          acc.helicopter += 1;
        }

        if (curr.assetType === 'Car') {
          acc.car += 1;
        }

        acc.patients += curr.patientsTreated || 0;
        return acc;
      },
      { helicopter: 0, car: 0, patients: 0 },
    );

    if (!results.length) {
      $('.missions-explorer-stats').fadeOut();
    } else {
      $('.missions-explorer-stats').fadeIn();
      $('#missionsExplorerStatHelicopter').text(stats.helicopter);
      $('#missionsExplorerStatCar').text(stats.car);
      $('#missionsExplorerStatPatients').text(stats.patients);
    }

    map.getSource('missions').setData({
      type: 'FeatureCollection',
      features: convertPointData(results),
    });

    if (results.length) {
      $('.missions-explorer-no-results-message').hide();
      const coordinates = results.map(f => [f.longitude, f.latitude]);
      const bounds = coordinates.reduce((acc, coord) => {
        return acc.extend(coord);
      }, new mapboxgl.LngLatBounds(coordinates[0], coordinates[0]));

      map.fitBounds(bounds, {
        padding: 80,
        maxZoom: 10,
      });
    } else {
      $('.missions-explorer-no-results-message').show();
      if (
        app.year === new Date().getFullYear() &&
        app.month > new Date().getMonth()
      ) {
        $('.missions-explorer-no-results-message__general').show();
        $('.missions-explorer-no-results-message__old').hide();
      } else {
        $('.missions-explorer-no-results-message__general').hide();
        $('.missions-explorer-no-results-message__old').show();
      }
    }
  };

  const convertPointData = data => {
    const newData = [];
    data.forEach(mission => {
      const { latitude, longitude, ...rest } = mission;
      const newMission = {
        type: 'Feature',
        geometry: {
          type: 'Point',
          coordinates: [longitude, latitude],
        },
        properties: { ...rest },
      };

      let i = 0;
      while (true) {
        if (!newData.find(m => _.isEqual(m.geometry, newMission.geometry)))
          break;
        const multiplier = Math.floor(i / 4) + 1;
        const distance = 0.01 * multiplier; //
        switch (i % 4) {
          case 1:
            newMission.geometry.coordinates[0] = longitude + distance;
            newMission.geometry.coordinates[1] = latitude + distance;
            break;
          case 2:
            newMission.geometry.coordinates[0] = longitude - distance;
            newMission.geometry.coordinates[1] = latitude + distance;
            break;
          case 3:
            newMission.geometry.coordinates[0] = longitude + distance;
            newMission.geometry.coordinates[1] = latitude - distance;
            break;
          case 0:
            newMission.geometry.coordinates[0] = longitude - distance;
            newMission.geometry.coordinates[1] = latitude - distance;
            break;
          default:
        }
        i += 1;

        if (i > 40000) {
          console.log(newMission);
          break;
        }
      }
      newData.push(newMission);
    });

    return newData.map(mission => ({
      ...mission,
      geometry: {
        ...mission.geometry,
        coordinates: [
          mission.geometry.coordinates[0], // + _.random(-0.008, 0.008),
          mission.geometry.coordinates[1], // + _.random(-0.008, 0.008),
        ],
      },
    }));
  };

  initMap();
})(jQuery);
